module.exports = __webpack_public_path__ + "img/prev.51fc037a.png";